<div *ngIf="openIdProfile">
    <h3>
        <div *ngIf="planModel">Edit plan {{ planModel.label }}</div>
        <div *ngIf="!planModel">Create new plan</div>
    </h3>

    <form [formGroup]="formGroup" (ngSubmit)="validate()" *ngIf="openIdProfile">
        <div class="form-group">
            <label>Label</label>
            <input
                required
                formControlName="label"
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter plan label"
            />
            <div
                class="form-control-invalid"
                *ngIf="formGroup.get('label')!.invalid"
            >
                Required
            </div>
        </div>

        <div class="form-group">
            <label>Description</label>
            <textarea
                required
                formControlName="description"
                class="form-control form-control-sm"
                placeholder="Description"
            ></textarea>
            <div
                class="form-control-invalid"
                *ngIf="formGroup.get('description')!.invalid"
            >
                Required
            </div>
        </div>
        <div class="form-group">
            <label>Webhook</label>
            <input
                formControlName="webhook"
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter absolute webhook url"
            />
        </div>

        <div class="form-check">
            <input type="checkbox" class="form-check-input" checked disabled />
            <label class="form-check-label">Allow subscriber overdraft</label>
        </div>

        <button type="submit" class="btn btn-primary btn-sm">Save</button>
        <span *ngIf="message">
            &nbsp;
            <button class="btn btn-secondary btn-sm">
                {{ message }}
            </button>
        </span>
    </form>
</div>
